<template>
  <v-container>
    <v-row align="center">
      <!-- Toggle Switch -->
      <v-col cols="2">
        <v-switch
          label="Use Dropbox"
          v-model="form_data_temp.is_dropbox"
          hide-details
          @change="resetFileData"
        />
      </v-col>

      <!-- File Upload / Dropbox Picker -->
      <v-col cols="8">
        <!-- Regular file upload -->
        <div v-if="!form_data_temp.is_dropbox">
          <div v-if="!form_data_temp.file">
            <div
              :class="['dropZone', dragging ? 'dropZone-over' : '']"
              @dragenter="dragging = true"
              @dragleave="dragging = false"
            >
              <div class="dropZone-info">
                <span class="fa fa-cloud-upload dropZone-title"></span>
                <span class="dropZone-title">Drop file or click to upload</span>
              </div>
              <input type="file" @change="onFileChange" />
            </div>
            <div class="error_message" v-if="form_errors.file">{{ form_errors.file }}</div>
          </div>
          <div v-else class="dropZone-uploaded">
            <div class="dropZone-uploaded-info d-flex">
              <div class="dropZone-title">
                {{ form_data_temp.file_name }}
                ({{ formatBytes(form_data_temp.file.size) }})
                <v-btn icon small @click="removeFile">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>

        <!-- Dropbox Picker -->
        <VueDropboxPicker
          :api-key="dropboxApiKey"
          link-type="direct"
          :multiselect="false"
          :folderselect="false"
          @cancel="onCancel"
          @picked="onPicked"
          v-show="form_data_temp.is_dropbox"
        >
          <v-text-field
            v-model="form_data_temp.file_name"
            color="primary"
            label="Select Document"
            placeholder="Click to select"
            append-icon="mdi-dropbox"
            prepend-icon
            outlined
            dense
            readonly
            :error-messages="form_errors.link"
            :hide-details="!form_errors.link"
          ></v-text-field>
        </VueDropboxPicker>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueDropboxPicker from "vue-dropbox-picker";

export default {
  components: { VueDropboxPicker },
  data() {
    return {
      dropboxApiKey: "zq0ioqqap9ils4e", // Replace with actual key
      dragging: false,
      form_errors: {
        file: null,
        link: null
      },
      form_data_temp: {
        is_dropbox: true,
        file_name: "",
        file: null,
        link: ""
      }
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.form_data_temp.file = file;
        this.form_data_temp.file_name = file.name;
      }
    },
    removeFile() {
      this.form_data_temp.file = null;
      this.form_data_temp.file_name = "";
    },
    onCancel() {
      console.log("Dropbox selection cancelled");
    },
    onPicked(link) {
      this.form_data_temp.file_name = link.name;
      this.form_data_temp.link = link.link;
      console.log("Dropbox file picked:", link);
    },
    resetFileData() {
      this.form_data_temp.file = null;
      this.form_data_temp.file_name = "";
      this.form_data_temp.link = "";
    },
    formatBytes(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    }
  }
};
</script>

<style scoped>
</style>

